import { AnyAction } from 'redux';
import {
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { BasisAdresse } from '@ps20-frontend/frontend-models';

export const risikoortReducer = function (
  sectionState: BasisAdresse = null,
  action: AnyAction,
): BasisAdresse {
  if (action.type === GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL) {
    const payload: AdressvorschlagPayload = action.payload;
    if (payload.callerId !== CALLER_ID.TKV_BASISDATEN) {
      return sectionState;
    }
    if (payload.orte?.length === 1) {
      const newState: BasisAdresse = { ...sectionState };
      newState.ort = payload.orte[0];
      return newState;
    }
  }
  return sectionState;
};
